<script type="text/javascript">
import Polygon from '../../templates/Polygon.vue'
export default Polygon.extend({
    data() {
        return {
            points: [19.8, 2.2, 6.6, 43.56, 39.6, 17.16, 0, 17.16, 33, 43.56],
            originalWidth: 43,
            originalHeight: 43,
            borders: 3
        }
    }
})
</script>



// WEBPACK FOOTER //
// star.vue?dd372ae4